import { Enums } from "@/enums";
import * as devalue from "devalue";
import { isNotNil } from "es-toolkit";
import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const CustomerComplaintRoutes = defineRoute({
    record: {
        route: {
            path: "/customer-complaint",
            component: () => loadView(import("./CustomerComplaintTable.vue")),
        },
        build(filter?: { status?: Enums.ComplaintStatusEnum.Values[] }) {
            if (isNotNil(filter)) {
                const encoded = btoa(devalue.stringify(filter));
                return `/customer-complaint?&filter=${encoded}`;
            }

            return "/customer-complaint";
        },
    },
    create: {
        route: {
            path: "/customer-complaint/create",
            component: () => loadView(import("./CustomerComplaintCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/customer-complaint/update/:id",
            component: () => loadView(import("./CustomerComplaintUpdate.vue")),
        },
        build(id: string) {
            return `/customer-complaint/update/${id}`;
        },
    },
});
